/* Shopify-native language selection. Never sends visitor IP to a third party. */
(() => {
  if (window.Shopify?.designMode) return;
  const element = document.getElementById('GrippedLocaleConfig');
  const form = document.getElementById('GrippedAutoLanguage');
  if (!element || !form) return;
  const config = JSON.parse(element.textContent);
  const preferenceKey = 'gripped:language:v1';
  const visitKey = 'gripped:geo-language:v1';
  const read = (storageName, key) => { try { return window[storageName].getItem(key); } catch { return null; } };
  const write = (storageName, key, value) => { try { window[storageName].setItem(key, value); } catch { /* Browsing without storage remains supported. */ } };
  let manualChoice = false;
  let interacted = false;
  // Capture before the existing custom element submits its localization form.
  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[name="language_code"]')) return;
    manualChoice = true;
    write('localStorage', preferenceKey, event.target.value);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target === form) return;
    const input = event.target.querySelector('[name="language_code"]');
    if (input) { manualChoice = true; write('localStorage', preferenceKey, input.value); }
  }, true);
  document.addEventListener('pointerdown', () => { interacted = true; }, { once: true, passive: true });
  document.addEventListener('keydown', () => { interacted = true; }, { once: true });
  const current = new URL(location.href);
  if (current.searchParams.has('preview_theme_id') || current.searchParams.has('pb') || current.searchParams.has('_fd') || !['index','product','collection','page','blog','article','search'].includes(config.page)) return;
  // A bookmarked/ad/search language URL is an explicit choice, even on a first visit.
  if (config.root !== '/') return;
  const choose = (code) => {
    if (manualChoice || interacted) return;
    const language = config.languages.find((entry) => entry.code === code);
    if (!language) return;
    write('sessionStorage', visitKey, '1');
    if (config.language === code) return;
    const target = new URL(current.href);
    target.pathname = (language.root === '/' ? '' : language.root.replace(/\/$/, '')) + current.pathname;
    form.querySelector('[name="language_code"]').value = code;
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo); }
    returnTo.value = target.pathname + target.search + target.hash;
    form.submit();
  };
  const preference = read('localStorage', preferenceKey);
  if (preference && config.languages.some((entry) => entry.code === preference)) { choose(preference); return; }
  if (read('sessionStorage', visitKey)) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1800);
  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin', signal: controller.signal })
    .then((response) => { if (!response.ok) throw new Error('geolocation unavailable'); return response.json(); })
    .then((data) => {
      const country = data.detected_values?.country?.handle;
      choose({ DE: 'de', FR: 'fr', ES: 'es', IT: 'it', PT: 'pt-PT' }[country] || 'en');
    })
    .catch(() => choose('en'))
    .finally(() => clearTimeout(timeout));
})();
